export const INTRO_STEPS = [
  {
    title: 'Verify your account for security',
    description: '30 seconds'
  },
  {
    title: 'Complete banking application',
    description: '3 minutes'
  },
  {
    title: 'Processing time',
    description: '30 seconds to 3 days'
  },
  {
    title: 'Start banking!'
  }
];
